import { createWebHistory, createRouter } from "vue-router";
import { setupRouterGuard } from "./router-guard.js";
import Forbidden from "./components/forbidden.vue";
import Home from "./components/home.vue";
import ResourceRedirect from "./components/resource-redirect.vue";
import Login from "./components/login.vue";
import Register from "./components/register.vue";
import Resources from "./components/resources.vue";
import Onboarding from "./components/onboarding.vue";
import SalesResourceUpdate from "./components/sales-resource-update.vue";
import CorporateResources from "./components/corporate-resources.vue";
import TaranaResources from "./components/tarana-resources.vue";
import Operators from "./components/operators.vue";
import SupplyChain from "./components/supply-chain.vue";
import Support from "./components/support.vue";
import Platforms from "./components/platforms.vue";
import Account from "./components/account.vue";
import Forgot from "./components/forgot.vue";
import ConfirmEmail from "./components/confirm-email.vue";
import VerifyToken from "./components/verify-token.vue";
import ResetPasswordForm from "./components/reset-password-form.vue";

const routes = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/resource-redirect",
    name: "Resource Redirect",
    component: ResourceRedirect,
  },
  {
    path: "/doc/:semanticUrl",
    name: "Resource Doc",
    component: ResourceRedirect,
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      hideForAuth: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Error",
    component: () => import("./components/error.vue"),
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    component: Forbidden,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      hideForAuth: true,
    },
  },
  {
    // security/0.4: `:token?` is optional so that both the new flow
    // (`/confirm-email?intent=<signed URL>`) and legacy links
    // (`/confirm-email/<opaque-id>`, now shown a retired-scheme error)
    // resolve to this component.
    path: "/confirm-email/:token?",
    name: "Confirm Email",
    component: ConfirmEmail,
    meta: {
      hideForAuth: false,
    },
  },
  {
    path: "/verify-token/:token?",
    name: "Verify Token",
    component: VerifyToken,
    meta: {
      hideForAuth: false,
    },
  },
  {
    path: "/forgot",
    name: "Forgot Password",
    component: Forgot,
    meta: {
      hideForAuth: true,
    },
  },
  {
    path: "/reset-password/:token/:email",
    name: "Reset Password",
    component: ResetPasswordForm,
    meta: {
      hideForAuth: true,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      hideForAuth: true,
    },
  },
  {
    path: "/account",
    name: "My Account",
    component: Account,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/resources",
    name: "Resources",
    component: Resources,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/sales-resource-update",
    name: "Sales Resource Update",
    component: SalesResourceUpdate,
    meta: {
      requiresAuth: true,
      permission: "sales-resource-update",
    },
  },
  {
    path: "/tarana-resources",
    name: "Tarana Resources",
    component: TaranaResources,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/corporate-resources",
    name: "Corporate Resources",
    component: CorporateResources,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/operators",
    name: "Operators",
    component: Operators,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/supply-chain",
    name: "Supply Chain",
    component: SupplyChain,
    meta: {
      requiresAuth: true,
      permission: "supply-chain",
    },
  },
  {
    path: "/onboarding/:page_name",
    name: "Customer Onboarding",
    component: Onboarding,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/support",
    name: "Support",
    component: Support,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/platforms/:page_name",
    name: "G1 Platform",
    component: Platforms,
    meta: {
      requiresAuth: false,
      permissions: ["link-gallery"],
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
  mode: "hash",
  scrollBehavior(to) {
    const hideForRoutes = [
      "Corporate Resources",
      "Tarana Resources",
      "Operators",
    ];
    if (!hideForRoutes.some((route) => to.name?.includes(route))) {
      return { left: 0, top: 0 };
    }
  },
});

setupRouterGuard(router);

export default router;
